import { View } from "binder"
import { TextInputViewModel } from "uicomponents";
import { AuthenticationViewModel } from "./authentication-viewModel"
import { BrandSelectorViewModel } from "src/Warehouse/brandManipulation/brandManipulation-viewModel";
import { warehouseLocationMultiSelectorViewModel } from "src/Warehouse/warehouseLocationManipulation/warehouseLocationManipulation-viewModel";

export class AuthenticationView extends View<AuthenticationViewModel>{
    GetViewUniqueId(): string {
        return "V-D24AE5F5-D605-46F6-A519-632DA7DF2334"
    }
    loadHtml(): string {
        let element = require('./authentication.html').default;
        let style = require('./authentication.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set isCredentialsWrong(v: boolean) { this._isCredentialsWrong = v; } public get isCredentialsWrong(): boolean { return this._isCredentialsWrong;} private _isCredentialsWrong: boolean;
        
    async login(){
        this.dataContext.login();
    }

    usernameKeyup(e:KeyboardEvent){
        if (e.key === 'Enter' || e.keyCode === 13) {
            let input :TextInputViewModel = (<any>this.firstlevelElement.querySelector('#passwordInput')).binderRelatedView.dataContext;
            input.focusInput();
        }
    }
    passwordKeyup(e:KeyboardEvent){
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.login();
        }
    }
}
